import React from 'react';
import './styles/main.css';

import RoutesHandler from './components/routesHandler';
import Navigation from './components/navigation';
import Footer from './components/footer';
import ProjectsContextProvider from '../src/providers/projects-context.provider';
import IssuesContextProvider from '../src/providers/issues-context.provider';
import SprintsContextProvider from '../src/providers/sprints-context.provider';
import TeamsContextProvider from '../src/providers/teams-context.provider';
import ErrorBoundary from '../src/components/error-boundary';
import { getAppSetting } from '../src/services/appsetting.service';

(async () => {
    const response = await getAppSetting();
	const { Version } = response;
	
	if(Version>0){
		let version = localStorage.getItem('version');
		console.log(version,Version);
		if(version!=Version)
		{
			if('caches' in window){
				caches.keys().then((names) => {
					names.forEach(name => {
						caches.delete(name);
					})
				});
	
				window.location.reload(true);
			}
			localStorage.clear();
			localStorage.setItem('version',Version);
		}
	}
	
})();

const App = () => {
	return (
		<div className="flex flex-col min-h-screen">
			<ProjectsContextProvider>
				<Navigation />
				<IssuesContextProvider>
					<SprintsContextProvider>
						<TeamsContextProvider>
							<ErrorBoundary>
								<RoutesHandler />
							</ErrorBoundary>
						</TeamsContextProvider>
					</SprintsContextProvider>
				</IssuesContextProvider>
				<Footer />
			</ProjectsContextProvider>
		</div>
	);
};

export default App;
